export default __webpack_public_path__ + "static/media/xmines_main_theme.552e7fdf.mp3";